<script setup>
import SportLiveTvControlButton from '@/sport-live-tv/components/sport-live-tv-control-button.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  visible: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvControlButton :active="visible" :aria-pressed="visible" :title="t(visible ? 'hideScores' : 'showScores')" :aria-label="t(visible ? 'hideScores' : 'showScores')" @click="emit('toggle')">
    {{ t('scores') }}
    <span class="sport-live-tv-scores-toggle__state">{{ t(visible ? 'scoresOn' : 'scoresOff') }}</span>
  </SportLiveTvControlButton>
</template>

<style lang="scss" scoped>
.sport-live-tv-scores-toggle__state {
  color: $gray;
  font-size: 13px;
}
</style>
